<div class="px-3">
    <div class="px-3">
        <h5 class="common-bene-class-for-translation"><b>Set default video call link</b></h5>
        <p class="common-bene-class-for-translation">Set your default video call link for all video call sessions. You will be able to override this default for an individual session.</p>
    </div>
    <div class="px-3 mb-3">
        <label class="w-100 d-block common-bene-class-for-translation">URL</label>
        <input class="w-50" type="text" pInputText [(ngModel)]="videoLink"/><i *ngIf="videoLink" class="fa text-primary fa-trash-o ml-3 fa-lg" style="cursor: pointer" (click)="confirmationPopup()"></i>
    </div>
    <div class="px-3 my-3">
        <button (click)="saveVideoLink()" [disabled]="!videoLink" class="btn btn-primary"><span class="common-bene-class-for-translation">Save</span></button>
    </div>
</div>
